import type { FaireProductEntity } from "../../entity_types/product";

export const p_pg7h6rbebb: FaireProductEntity = {
  token: "p_pg7h6rbebb",
  type: "product",
  name: "Vancouver Decaf Craft Instant Coffee",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/3fcbfe2fdaf67c3cb5bad4d07c0123eb04f89b20625df78a8a4ac81a3b6f2d75.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0da3bb07d49074f90bd47a4b9b8f390826778a2400b32d911406c15cea266d94.jpeg"
  ],
  priceDollars: 10,
  description: "Naturally decaffeinated, Vancouver Decaf delivers a satisfying cup and notes of almond and cola with none of the caffeine.\n\nAmazing things come in tiny packages. Verve Craft Instant Coffee is hand-roasted, small-batch brewed and preserved for your adventures. Ready to be brewed wherever and whenever. A week’s worth of premium coffee in your pocket.\n\nAdd one packet of Verve Craft Instant Coffee into your mug along with 10 ounces of hot or cold liquid (water, milk, or milk alternative), stir, and drink up.\n\nMakes 6 cups of coffee.\n\n• Coffee Details Country\n• Colombia, Uganda\n\n𝗧𝗮𝘀𝘁𝗶𝗻𝗴 𝗡𝗼𝘁𝗲𝘀\n• Almond, Honey, Cola\n\n𝗣𝗿𝗼𝗱𝘂𝗰𝗲𝗿\n• Various Producers\n\n𝗣𝗿𝗼𝗰𝗲𝘀𝘀\n• Swiss Water Processed\n\n𝗘𝗹𝗲𝘃𝗮𝘁𝗶𝗼𝗻\n• 1,400 - 1,500 Meters\n\n𝗛𝗮𝗿𝘃𝗲𝘀𝘁\n• October - March",
  tags: [],
  msrpDollars: 16.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:08.234Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
